<script>
import ListOfObjects from "@/views/product/components/product-card/composition/components/ListOfObjects.vue";
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
    components: {ListOfObjects, BFormGroup, vSelect},
    props: {
        readOnly: {
            default: false,
        },
        value: {},
        config: {
            type: Object,
            default() {
                return {
                    data: []
                };
            }
        },
        applyWarningClass: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            componentValue: this.value
        };
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        }
    },
}
</script>

<template>
    <div>
        <div v-if="readOnly">
            <h5>{{ $t('Component(CompositionSubstance):additional-material') }}</h5>
            <div v-if="!value || value.length === 0">-</div>
            <ListOfObjects v-else :elements="value"/>
        </div>
        <b-form-group
            v-else
            :label="$t('Component(CompositionSubstance):additional-material')"
        >
            <v-select
                v-model="componentValue"
                label="title"
                :class="{ 'input-bg-warning': applyWarningClass }"
                :title="$t('Component(CompositionSubstance):hover-material-category')"
                :options="config.data"
                multiple
                @input="onInput"
                :placeholder="$t('Component(CompositionSubstance):material-category-placeholder')"
                :disabled="readOnly"
            />
        </b-form-group>
    </div>
</template>
